import React from "react";
import { Typography } from "@mui/material";

import PageLayout from "@/components/layouts/page/PageLayout";
import EmailCampaignList from "../components/campaign-list/EmailCampaignList";
import { emailCampaigns } from "../utils/emailCampaignsDummyData";

function EmailCampaignsPage() {
  return (
    <PageLayout className="participant-dashboard-container mx-0 mx-sm-2">
      <div className="dashboard participant-dashboard">
        <Typography variant="h5" className="widget-title mb-4 mb-md-auto">
          Email Campaigns
        </Typography>

        <EmailCampaignList campaigns={emailCampaigns} />
      </div>
    </PageLayout>
  );
}

export default EmailCampaignsPage;
